/**
 * Remarks - Represents remarks or notes.
 * Used to store additional comments, notes, or remarks throughout the application.
 */
export class Remarks {
  /** Remarks text */
  Remarks: string;

  /**
   * Creates a new Remarks instance
   * @param data - Object containing remarks properties
   */
  constructor(data: {
    Remarks: string;
  }) {
    this.Remarks = data.Remarks;
  }

  /**
   * Creates a Remarks from a plain object (useful for deserialization)
   * @param obj - Plain object with remarks data
   * @returns New Remarks instance
   */
  static fromObject(obj: Partial<Remarks>): Remarks {
    return new Remarks({
      Remarks: obj.Remarks ?? "",
    });
  }

  /**
   * Converts the Remarks to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      Remarks: this.Remarks,
    };
  }
}


